import { initializeAppInsights } from '@shared/infrastructure/logger/applicationInsightsService';
import { RoutesRenderer } from './infrastructure/router/routesRenderer';

initializeAppInsights();
function App() {
  return <RoutesRenderer></RoutesRenderer>;
}

export default App;
